import React from 'react';
import { Grid } from '@mui/material';
import PopupTitle from '../../../components/common/popup_title';

const MealBasketPageLoading = () => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <PopupTitle titleText="Please wait..." backButtonEnabled={false} />
      </Grid>
    </Grid>
  );
};

export default MealBasketPageLoading;
